module.exports = __webpack_public_path__ + "img/edge_activites_paddle.39b07527.svg";